module.exports = __webpack_public_path__ + "static/media/image_66.7aebdcbf.png";